var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIconBlueReturns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37109 10C3.37109 9.58581 3.70688 9.25002 4.12109 9.25002H15.8799C16.2941 9.25002 16.6299 9.58581 16.6299 10C16.6299 10.4142 16.2941 10.75 15.8799 10.75H4.12109C3.70688 10.75 3.37109 10.4142 3.37109 10Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 16.6294C9.5863 16.6294 9.25051 16.2937 9.25051 15.8794V4.12061C9.25051 3.70639 9.5863 3.37061 10.0005 3.37061C10.4147 3.37061 10.7505 3.70639 10.7505 4.12061V15.8794C10.7505 16.2937 10.4147 16.6294 10.0005 16.6294Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconBlueReturns);
export default __webpack_public_path__ + "static/media/plus-icon-blue-returns.badd2668f806abb28a75c705e62b89a0.svg";
export { ForwardRef as ReactComponent };